import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminLeaderInformationItems = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LEADER_INFORMATION_ITEMS.GET_ALL, { params });
    return response.data;
};

export const getAdminLeaderInformationItemById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LEADER_INFORMATION_ITEMS.GET_BY_ID(id));
    return response.data;
};

export const createLeaderInformationItemsBatch = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.LEADER_INFORMATION_ITEMS.CREATE_BATCH, data);
    return response.data;
};

export const updateLeaderInformationItem = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.LEADER_INFORMATION_ITEMS.UPDATE(id), data);
    return response.data;
};

export const deleteLeaderInformationItem = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.LEADER_INFORMATION_ITEMS.DELETE(id));
    return response.data;
};
